

























































































































































































































































import { NumberWings, SelectWings } from "wings-ui-components";
import { AccountItem } from "@/store/settings/accounts/types";
import { PartnerItem } from "@/store/settings/partners/types";
import {
  IncomingTariffsItem,
  IncomingTariffsItemInfo,
  Provider,
  ProviderModule,
} from "@/store/tarification/incoming_tariffs/types";
import { dateFilter } from "@/utils/date-util";
import {
  notifyConfirm,
  notifyDelete,
  notifyError,
  notifySuccess,
} from "@/utils/notify-helper";
import {cloneDeep, isEqual} from "lodash";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { AxiosResponse } from "axios";
import { SmppConnectionItem } from "@/store/settings/smpp_connections/types";
import { extend } from "vee-validate";
import { MsgTransports } from "@/store/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

Component.registerHooks(["beforeRouteLeave"]);

@Component({
  components: { NumberWings, SelectWings },
  filters: { dateFilter },
})
export default class IncomingTariff extends Vue {
  @Ref("validator") validator: any;
  @Prop() transport!: MsgTransports;

  @Action("getIncomingTariffsInfo") actionGetItem: any;
  @Action("saveIncomingTariff") actionSave: any;
  @Action("deleteIncomingTariff") actionDelete: any;

  @Action("getPartners") actionGetPartners: any;
  @Action("getAccounts") actionGetAccounts: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getSmppConnections") actionGetSmppConnections: any;
  @Action("actionLog") actionLog: any;

  @Getter("incomingTariffs")

  incomingTariffsItems!: IncomingTariffsItem[];

  item: IncomingTariffsItemInfo = this.defaultItem();
  itemSaved: IncomingTariffsItemInfo = this.defaultItem();
  initialItem: IncomingTariffsItemInfo = this.defaultItem();
  private logObject: ActionLog = {};

  params = { transport: this.transport };
  partnersList: any = []
  accountsList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getAccountsList(filter: any) {
    const items = await this.actionGetAccounts({partner_id: this.item.partner_id, ...this.params, ...filter});
    this.accountsList = (filter?.page_number > 1) ? this.accountsList.concat(items) : items
  }

  defaultItem(): IncomingTariffsItemInfo {
    return new IncomingTariffsItemInfo();
  }

  async created() {
    let resp: AxiosResponse<{ connections: SmppConnectionItem[] }>;

    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "The rule for routing incoming messages",
          addititional_info: getTranslatedParams(this.item)
        }
        this.item = await this.actionGetItem({
          id: this.$route.params.id,
          transport: this.transport,
        });
        await this.actionLog(this.logObject);
        this.item.id = Number(this.$route.params.id);
        this.itemSaved = cloneDeep(this.item);
        this.initialItem = cloneDeep(this.item);
      } catch (err) {
        this.actionLog({...this.logObject, action_status: "failed"});
      }
      if (this.item.partner_id) this.partnersList = await this.actionGetPartners({id: this.item.partner_id});
      if (this.item.broker_account_id) this.accountsList = await this.actionGetAccounts({id: this.item.broker_account_id});
    } else {
      if (this.transport === MsgTransports.SMS) {
        resp = await this.actionGetSmppConnections();
        this.item.setProviderModules(resp.data.connections);
      } else {
        let param = {
          transport: this.transport,
          protocols: "SMSTraffic",
        };

        let service_providers = await this.actionGetServiceProviders(param);
        let providerModule: Provider;
        service_providers.forEach((e: any) => {
          providerModule = new Provider();
          providerModule.service_provider_id = e.id;
          providerModule.service_provider = e.name;
          this.item.provider_modules.push(providerModule);
        });
      }
      this.itemSaved = cloneDeep(this.item);
    }
    this.$nextTick();
    this.validationSetup();
  }

  validationSetup() {
    extend("provider_modules_required", {
      validate: (modules: ProviderModule[]) => {
        return Boolean(
          modules.find((module: ProviderModule) => module.is_allowed)
        );
      },
      message: this.$t("not_selected_service_providers") as string,
    });
    extend("priority_unique", {
      validate: (priority: number | string) => {
        let result: boolean = !Boolean(
          this.incomingTariffsItems.find(
            (tariff: IncomingTariffsItem) =>
              tariff.priority === Number(priority)
          )
        );
        result =
          this.$route.params.id &&
          this.initialItem.priority === Number(priority)
            ? true
            : result;
        return result;
      },
      message: this.$t("priority_exist") as string,
    });
    extend("priority_greater_than_zero", {
      validate: (priority: number | string) => {
        return Number(priority) > 0;
      },
      message: this.$t("priority_more_zero") as string,
    });
  }

  get filteredAccountsList(): AccountItem[] {
    const filteredList: AccountItem[] = this.accountsList.filter(
      (account: AccountItem) =>
        this.item.partner_id
          ? this.getPartnerNameById(this.item.partner_id) === account.partner && this.checkSMPPTransport(account)
          : false
    );
    return filteredList;
  }

  getPartnerNameById(id: number): string | undefined {
    const findedPartner: PartnerItem | undefined = this.partnersList.find(
      (partner: PartnerItem) => partner.id === id
    );
    return findedPartner?.name;
  }

  checkSMPPTransport(account: AccountItem): boolean {
    return account?.transports?.includes(this.transport) || false;
  }

  get partnerNeededMessage() {
    return !this.item.partner_id ? this.$t("choose_client") : "";
  }

  @Watch("item.partner_id", { immediate: true })
  onPartnerChange(newVal: any, oldVal: any) {
    if (oldVal) {
      this.item.broker_account_id = null;
    }
  }

  async onSaveItem(): Promise<void> {
    return new Promise(async () => {
      const valid: boolean = await this.validator.validate();
      if (!valid) {
        setTimeout(() => {
          notifyError(null, this.validator.errors);
        }, 100);
        return;
      }
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: this.$route.params.id ? "Editing" : "Creation",
          action_status: "success",
          object_type: "The rule for routing incoming messages",
          addititional_info: getTranslatedParams(this.item)
        }
        await this.actionSave({ tariff: this.item, transport: this.transport });
        await this.actionLog(this.logObject);
        setTimeout(() => {
          notifySuccess(this.$t("dialog.success").toString());
          this.itemSaved = this.item;
          this.back();
        }, 100);
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    });
  }

  async onDeleteItem(): Promise<void> {
    const isConfirm: boolean = await notifyDelete();
    if (!isConfirm) {
      return;
    }
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Removal",
        action_status: "success",
        object_type: "The rule for routing incoming messages",
        addititional_info: getTranslatedParams({id: this.item.id})
      }
      await this.actionDelete({ tariff: this.item, transport: this.transport });
      await this.actionLog(this.logObject);
      setTimeout(() => {
        notifySuccess(this.$t("dialog.success").toString());
        this.itemSaved = this.item;
        this.back();
      }, 100);
    } catch (error) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(error);
    }
  }

  back(): void {
    this.$router.push(`/${this.transport.toLowerCase()}/incoming_tariffs/`);
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }
}
